module.exports = __webpack_public_path__ + "img/icon-change-password-key.25fdd59f.svg";